<div class="container">
  <ng-container *ngIf="isShowIdentifierBlock">
    <div
      class="row"
      *ngIf="
        !!entity.entityIdentifier ||
        getValidationText('entityIdentifier') ||
        !!entity.entityIdentifierQualifier ||
        getValidationText('entityIdentifierQualifier')
      "
    >
      <div class="col-12 col-sm-6">{{ "LABELS.ID_NUMBER" | translate }}</div>
      <ng-container
        *ngIf="!getValidationText('entityIdentifier') || !getValidationText('entityIdentifierQualifier'); else missedIdentifier"
      >
        <div class="col-12 col-sm-6">
          {{ "IDENTIFIER_QUALIFIER." + entity.entityIdentifierQualifier | translate }} {{ entity.entityIdentifier | identifier }}
        </div>
      </ng-container>
      <ng-template #missedIdentifier>
        <div class="col-12 col-sm-6 text-error">
          {{ getValidationText("entityIdentifier") || getValidationText("entityIdentifierQualifier") | translate }}
        </div>
      </ng-template>
    </div>
    <div class="row" *ngIf="!!entity.dateOfBirth || getValidationText('dateOfBirth')">
      <div class="col-12 col-sm-6">{{ "FORM_LABEL.DATEOFBIRTH" | translate }}</div>
      <ng-container *ngIf="!getValidationText('dateOfBirth'); else missedDateOfBirth">
        <div class="col-12 col-sm-6">{{ entity.dateOfBirth | customDateByUtc }}</div>
      </ng-container>
      <ng-template #missedDateOfBirth>
        <div class="col-12 col-sm-6 text-error">{{ getValidationText("dateOfBirth") | translate }}</div>
      </ng-template>
    </div>
  </ng-container>
  <div class="row" *ngIf="!!entity.name || getValidationText('name')">
    <div class="col-sm-6">{{ "LABELS.NAME" | translate }}</div>
    <ng-container *ngIf="!getValidationText('name'); else missedName">
      <div class="col-12 col-sm-6">{{ entity.name }}</div>
    </ng-container>
    <ng-template #missedName>
      <div class="col-12 col-sm-6 text-error">{{ getValidationText("name") | translate }}</div>
    </ng-template>
  </div>
  <div class="row" *ngIf="(!!entity.address || getValidationText('address')) && entity.entityCode !== enumEntityModelCode.CONSIGNEE">
    <div class="col-12 col-sm-6">{{ "LABELS.ADDRESS" | translate }}</div>
    <ng-container *ngIf="isValidIsfEntityAddress(); else missedAdd">
      <div class="col-12 col-sm-6" *ngIf="!getValidationText('address')">
        <address-details [address]="entity.address"></address-details>
      </div>
      <div class="col-12 col-sm-6 text-error" *ngIf="getValidationText('address')">
        {{ getValidationText("address") | translate }}
      </div>
    </ng-container>
    <ng-template #missedAdd>
      <div class="col-12 col-sm-6 text-error">{{ "BACK_ERROR.MISSING_ADDRESS_PARTS" | translate }}</div>
    </ng-template>
  </div>
</div>
